import { forgotPassword } from './pages/forgotPassword';
import { geolocationDenied } from './pages/geolocationDenied';
import { login } from './pages/login';
import { validateToken } from './pages/validateToken';

export const en = {
  pages: {
    login,
    forgotPassword,
    geolocationDenied,
    validateToken,
  },
  components: {
    languageSwitch: {
      label: 'Change language',
      pt: 'Portuguese',
      en: 'English',
      es: 'Spanish',
    },
    servicesSelection: {
      title: 'Select services',
      selectAtLeastOne: 'Select at least one service',
      next: 'Next',
    },
    additionalFields: {
      title: 'Additional Fields',
      back: 'back',
      zipLabel: 'ZIP code',
      phoneLabel: 'Phone',
      emailLabel: 'E-mail',
      next: 'Next',
      zipRequired: 'ZIP code is required!',
      phoneRequired: 'Phone is required!',
      emailRequired: 'E-mail is required!',
    },
    bodyStep: {
      identificationBy: 'Identification by {{validation}}',
      companyLabel: 'Company:',
      userLabel: 'User:',
      signOut: 'Sign out',
      versionLabel: 'Version:',
      apiVersionLabel: 'API Version:',
      providerLabel: 'Provided by:',
      stepMeta: 'Step {{current}} of {{total}}',
      back: 'Back',
    },
    summary: {
      title: 'Service summary',
      openButton: 'View summary',
      close: 'Close',
      analysisTypeLabel: 'Analysis type',
      analysisTypeCnh: 'ID/Passport + photo',
      analysisTypeFace: 'Face photo',
      analysisTypeData: 'Data entry',
      analysisTypePj: 'Company (legal entity)',
      nameLabel: 'Name',
      documentLabel: 'Document',
      servicesLabel: 'Selected services',
      allServices: 'All contracted services',
      findingsCount: 'Findings for this service',
      outcomeFindings: 'This service found records',
      outcomeFailed: 'This service failed — result not obtained',
      outcomeClean: 'This service found nothing',
      empty: 'Not provided yet',
    },
    camera: {
      title: 'Photo',
      back: 'back',
      clear: 'CLEAR',
      next: 'NEXT',
      uploadImage: 'UPLOAD IMAGE',
      camera: 'CAMERA',
      takePhoto: 'TAKE PHOTO',
    },
    choose: {
      title: 'Select analysis method',
      back: 'back',
      photoOption: 'Analysis by photo',
      cnhOption: 'Analysis by ID/Passport photo',
      faceOption: 'Analysis by face photo',
      dataOption: 'Analysis by Data Entry',
    },
    flowChooser: {
      title: 'What do you need to check?',
      pfTitle: 'Individual checks',
      pjTitle: 'Company checks',
      description:
        'Run a complete search based on the checks previously authorized by your company',
      unavailable: 'Option available for purchase. Contact our sales team.',
    },
    companyIdentification: {
      title: 'Company Information',
      back: 'back',
      documentLabel: 'CNPJ',
      documentPlaceholder: '00.000.000/0000-00',
      next: 'Search',
      documentInvalid: 'Invalid CNPJ',
      requestFailed: 'The check could not be completed. Please try again.',
    },
    identification: {
      title: 'Personal Information',
      back: 'back',
      nameLabel: 'Full name',
      birthLabel: 'Date of birth',
      documentTypeLabel: 'Document type',
      documentNumberLabel: 'Document number',
      next: 'Next',
      nameRequired: 'Name is required!',
      birthRequired: 'Date of birth is required!',
      documentInvalid: 'Invalid document',
    },
    instructions: {
      title: 'Instructions',
      back: 'back',
      next: 'Next',
      selfie: {
        faceVisible: 'Take a selfie with your face centered and visible',
        goodLighting: 'Find good lighting',
        removeAccessories: 'Remove accessories such as glasses and hats',
        avoidRotation: 'Avoid rotating the device camera',
      },
      document: {
        flatSurface: 'Place the document on a flat surface',
        goodLighting: 'Find good lighting',
        adjustFocus: 'Adjust the focus to ensure quality',
        avoidRotation: 'Avoid rotating the device camera',
      },
    },
    result: {
      title: 'Result',
      fullName: 'Full name',
      document: 'Document',
      failureMessage: 'The check failed. Please try again.',
      biometryLabel: 'Facial biometrics',
      findingsOverview: {
        withServices: 'record(s) found in:',
        total: 'record(s) found in this check.',
      },
      status: {
        recommended: 'NO FINDINGS',
        notRecommended: 'WITH FINDINGS',
        failed: 'FAILED',
      },
      process: {
        subject: 'Subject',
        branch: 'Area',
        type: 'Case type',
        judgingBody: 'Issued by',
        defendands: 'Defendants',
        date: 'Filing date',
        status: 'Status',
        lawsuitNr: 'Case number',
        value: 'Case value',
      },
      buttons: {
        returnToPlatform: 'Return to SGRLOC platform',
        tryAgain: 'Try again',
        backToStart: 'Back to start',
      },
    },
    resultDetails: {
      notInformed: 'Not provided',
      titles: {
        score: 'Credit score',
        dados_pj: 'Company data',
        validacao_pj: 'Registration status',
      },
      score: {
        classLabel: 'Class',
        pointsLabel: 'Score',
        bandScalePf: 'bands — individual',
        bandScalePj: 'bands — company',
        restrictionsTitle: 'Restrictions',
        debts: 'Debts',
        protests: 'Protests',
        checks: 'Bounced checks',
        recordsCount: '{{count}} record(s)',
        incomePresumed: 'Estimated income',
        revenueEstimated: 'Estimated revenue',
        notProven: 'Provider estimate, not verified',
        consultDate: 'Obtained on',
        disclaimer:
          'The score is informational: findings depend only on restrictions. Use it only as support in the decision process.',
      },
      company: {
        registrationSection: 'Registration data',
        corporateName: 'Legal name',
        tradeName: 'Trade name',
        openingDate: 'Opening date',
        companyAge: 'Company age',
        companyAgeValue: '{{years}} year(s)',
        registrationStatus: 'Registration status',
        registrationStatusDate: 'Status date',
        size: 'Size',
        legalNature: 'Legal nature',
        cnae: 'CNAE',
        partners: 'Partners',
        partnerSince: 'since {{date}}',
        addresses: 'Addresses',
        phones: 'Phones',
        phoneMobile: 'mobile',
        phoneLandline: 'landline',
        emails: 'E-mails',
      },
    },
    optIn: {
      title: 'Terms of Use',
      checkboxText: 'I have read and agree to these terms and conditions',
      buttons: {
        accept: 'Accept',
        refuse: 'Decline',
      },
    },
    faceTecCamera: {
      back: 'back',
      titleCaptured: 'Captured photo',
      titleDefault: 'Photo',
      buttons: {
        clear: 'CLEAR',
        next: 'NEXT',
        startCamera: 'START CAMERA',
      },
      loadingCapture: 'Loading capture',
      capturedAlt: 'Captured photo',
    },
    loading: {
      alt: 'Loading...',
    },
    dropzone: {
      documentAlt: 'Document image',
      placeholder: 'Select your document',
      fileTooLarge: 'Maximum image size must be 1MB',
    },
    logos: {
      sgrLoc: 'SGRLoc logo',
      swint: 'Odeen logo',
    },
  },
};

export default en;
